import React from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import BarChart from "../../Charts/BarChart";
import TableToggle from '../TableToggle';
import { Col, Row } from 'react-bootstrap';
import { USDollar } from '/src/utilities/formats';
import KeyValueData from '../../Charts/KeyValueData';
import useTableToggle from '../../Hooks/useTableToggle';
import { colors } from '../../../utilities/formats';

export default function ResearchSpending({ institutionData }) {

    const { table, handleTable } = useTableToggle();
    const title = "Research Spending";
    const spending = []

    const fields = {
        rd_comp: "Computer and Information Sciences",
        rd_geo: "Geosciences, Atmospheric sciences, and Ocean sciences",
        rd_life: "Life Sciences",
        rd_math: "Mathematics and Statistics",
        rd_physical: "Physical Sciences",
        rd_psych: "Psychology",
        rd_social: "Social Sciences",
        rd_sciences: "Sciences (other)",
        rd_engin: "Engineering",
        rd_all_non_se: "All Non-S&E fields",
    }

    Object.entries(fields).forEach(([key, userFriendlyLabel]) => {
        const field = institutionData.post_meta[key];
        if (typeof (field) != 'undefined' && field.value > 0) {
            const fieldData = {
                label: userFriendlyLabel,
                value: field.value
            };
            spending.push(fieldData);
        }
    });

    spending.sort((a, b) => b.value - a.value);

    const total = institutionData.post_meta.rd_total_spend.value;
    if (!total) {
        return <NoData widgetTitle={title} />;
    }

    return (
        <Widget className="research-spending">
            <Row gap={5} gap-lg={0} className='mb-4'>
                <Col xs={12} sm={9} className='d-flex align-items-center'>
                    <img className='me-2' src="/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/widgets/research-activity-designation/icon-research-spending.svg"
                        alt="Research Activity Designation" width="50" height="50" />
                    <WidgetTitle className="mb-0">{title}</WidgetTitle>
                </Col>
                <Col xs={12} sm={3} className='d-flex align-items-center justify-content-end'>
                    <TableToggle handleTable={handleTable} table={table} />
                </Col>
            </Row>
            <p><strong>Total Research Spending:</strong> {USDollar.format(total)}</p>
            <p>Research Spending by Program:</p>
            {!table ?
                spending.map((spend, i) => {
                    return (
                        <div className='my-2' key={i}>
                            <BarChart data={spend} total={total} color={colors.green} currency={true} />
                        </div>
                    );
                })
                : <KeyValueData data={spending} />}
        </Widget >);
}